import { useCallback } from "react";

import {
  RydeProcessTitle,
  type IRydeProcess,
  type RydeUiUnit,
  type TAddressedFieldsValueOnCompleted,
} from "@ryde/shared";

import { useDynamicFormsFetch } from "../use-dynamic-forms-fetch";
import { useWatchBulkProcessCompletion } from "./use-watch-bulk-process-completion";

export const useWatchBulkBookingClone = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const { fetchTableRowsServerFiltered } = useDynamicFormsFetch(
    "booking",
    "bookings",
  );

  // The copies are new rows, so the view has to be fetched again to show them.
  const onCompleted = useCallback(
    (process: Partial<IRydeProcess>) => {
      fetchTableRowsServerFiltered();
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted, fetchTableRowsServerFiltered],
  );

  useWatchBulkProcessCompletion({
    entity,
    processTitle: RydeProcessTitle.BulkCloneBookings,
    addressedFieldsValueOnCompleted: onCompleted,
  });
};
